var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProductBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    clipPath: "url(#clip0_8211_25227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.1466 4.20212L8.14656 0.702117C8.05273 0.655284 7.94206 0.655284 7.8484 0.702117L0.848396 4.20212C0.735396 4.25862 0.664062 4.37395 0.664062 4.50028V11.5003C0.664062 11.6266 0.735396 11.742 0.848229 11.7985L7.84823 15.2985C7.89523 15.322 7.94623 15.3336 7.9974 15.3336C8.04856 15.3336 8.09956 15.322 8.14656 15.2985L15.1466 11.7985C15.2594 11.742 15.3307 11.6266 15.3307 11.5003V4.50028C15.3307 4.37395 15.2594 4.25862 15.1466 4.20212ZM7.9974 1.37295L14.2521 4.50028L12.9141 5.16928L6.65956 2.04195L7.9974 1.37295ZM10.2474 6.50262L3.99273 3.37528L5.91406 2.41462L12.1687 5.54195L10.2474 6.50262ZM10.4974 7.12295L12.4974 6.12295V8.60245L11.8577 8.14562C11.7852 8.09378 11.6946 8.07328 11.6067 8.08845C11.5189 8.10395 11.4407 8.15378 11.3899 8.22712L10.4974 9.51662V7.12295ZM3.2474 3.74795L9.5019 6.87528L7.9974 7.62762L1.74273 4.50028L3.2474 3.74795ZM1.33073 5.03962L7.66406 8.20628V14.4608L1.33073 11.2941V5.03962ZM8.33073 14.461V8.20628L9.83073 7.45628V10.5836C9.83073 10.7295 9.9254 10.8583 10.0646 10.9018C10.0976 10.9121 10.1309 10.917 10.1641 10.917C10.2714 10.917 10.3747 10.865 10.4382 10.7735L11.7457 8.88495L12.6372 9.52162C12.7389 9.59412 12.8726 9.60395 12.9834 9.54662C13.0942 9.48962 13.1641 9.37512 13.1641 9.25028V5.78962L14.6641 5.03962V11.2941L8.33073 14.461Z",
    fill: "#BDBDBD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8211_25227"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductBox);
export default __webpack_public_path__ + "static/media/product-box.e801fec297a86a9c3fa4c8f115daeb04.svg";
export { ForwardRef as ReactComponent };